// 横スクロールメニュー１つ１つのアイテム
import "./index.css"
const MenuItem = (props) =>{
    const {isSelect,children,setSelectedId,categoryId} = props;
    return(
        isSelect ? <div className="menuitem-selected-container">{children}</div>:<button onClick={()=>{setSelectedId(categoryId)}} className="menuitem-non-selected-container">{children}</button>
    )
}
export default MenuItem